<template>
  <div>
    <div class="d-flex justify-space-between align-center pa-4 pa-md-2">
      <div>
        <Breadcrumbs headline="Giáo viên" :link="[{ text: 'Giáo viên', href: '../teachers' }]" />
      </div>

      <div>
        <v-btn
          medium
          class="teacher-btn"
          color="primary"
          @click="createState = !createState"
          v-if="['super_admin', 'education_manager'].includes(role.type)"
        >
          <v-icon left>add</v-icon>
          <span>{{ titleBtn }}</span>
        </v-btn>
      </div>
    </div>

    <v-card class="pa-2 mx-md-2">
      <v-data-table
        :items-per-page="5"
        item-key="id"
        :headers="visibleHeaders"
        :items="teacherToDisplay"
        :loading="isLoading"
        loading-text="Đang Tải"
        :search="search"
        dense
      >
        <template v-slot:top>
          <div class="d-flex justify-space-between align-center">
            <teacher-filter @onFilterChanged="onFilterChanged" class="flex-fill"> </teacher-filter>
            <v-menu :close-on-content-click="false">
              <template v-slot:activator="{ on }">
                <v-btn text v-on="on" icon class="ml-2">
                  <v-icon>mdi-settings</v-icon>
                </v-btn>
              </template>
              <v-list class="px-2" dense style="width: 200px">
                <v-list-item
                  v-show="header.configurable"
                  dense
                  v-for="header in headers"
                  :key="header.value"
                >
                  <v-checkbox
                    class="mt-0"
                    hide-details="auto"
                    small
                    :label="header.text"
                    :input-value="header.show"
                    @change="onToggleHeader(header.value, !header.show)"
                  ></v-checkbox
                ></v-list-item> </v-list
            ></v-menu>
          </div>
        </template>
        <template v-slot:item.dob="{ item }"> {{ formatDob(item.dob) }}</template>
        <template v-slot:item.gender="{ item }"> {{ getGenderLabel(item.gender) }}</template>
        <template v-slot:item.facebook="{ item }">
          <a :href="item.facebook" v-if="item.facebook" target="_blank"> {{ item.facebook }}</a
          ></template
        >

        <template v-slot:[`item.name`]="{ item }">
          <user-item :teacher="item" :to="'teacher/' + item.id"></user-item>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <teacher-list-actions
            class="justify-center"
            v-if="['super_admin', 'education_manager'].includes(role.type)"
            :item="item"
          ></teacher-list-actions>
        </template>

        <template v-slot:[`item.majors`]="{ item }">
          <span v-if="item.majors">{{ item.majors | getMajors }}</span>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <span :class="getColor(item.status)">{{ item.status | getStatus }}</span>
        </template>
      </v-data-table>
    </v-card>
    <new-teacher-dialog :state="createState" />
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import UserItem from '@/components/basic/card/CardTeacherName.vue'
import TeacherFilter from '@/modules/teacher/TeacherFilter.vue'
import TeacherListActions from '@/modules/teacher/TeacherListActions'
import NewTeacherDialog from '@/modules/teacher/TeacherNewDialog'
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import SettingTableHeader from '@/components/basic/table/SettingHeaders'
import ExportExcel from '@/components/basic/ExportExcel'
import KebapMenu from '@/components/basic/menu/KebapMenu.vue'
import Vuetify from 'vuetify'
import Vue from 'vue'
import moment from 'moment'
import { getGenderLabel } from '../../helpers'
Vue.use(Vuetify)

export default {
  components: {
    Breadcrumbs,
    UserItem,
    TeacherFilter,
    TeacherListActions,
    SettingTableHeader,
    ExportExcel,
    KebapMenu,
    NewTeacherDialog
  },
  data() {
    return {
      filters: {},
      headers: [
        {
          text: 'STT',
          value: 'index',
          align: 'center',
          sortable: false,
          show: true
        },
        {
          text: 'Họ tên',
          value: 'name',
          align: 'left',
          sortable: false,
          show: true
        },
        {
          text: 'Mã nhân viên',
          value: 'code',
          align: 'left',
          sortable: true,
          show: true
        },
        // {
        //   text: 'Chuyên ngành',
        //   value: 'majors',
        //   align: 'left',
        //   sortable: false,
        //   show: true
        // },
        {
          text: 'Số Điện Thoại',
          value: 'phone',
          align: 'left',
          sortable: false,
          show: true
        },
        {
          text: 'Email',
          value: 'email',
          align: 'left',
          sortable: false,
          show: true
        },
        {
          text: 'Trạng thái',
          value: 'status',
          align: 'center',
          sortable: false,
          show: true
        },
        {
          text: 'Giới tính',
          value: 'gender',
          align: 'center',
          sortable: false,
          show: false,
          configurable: true
        },
        {
          text: 'Facebook',
          value: 'facebook',
          align: 'center',
          sortable: false,
          show: false,
          configurable: true,
          width: 240
        },
        {
          text: 'Ngày sinh',
          value: 'dob',
          align: 'center',
          sortable: false,
          show: false,
          configurable: true
        },
        {
          text: 'Hành động',
          value: 'actions',
          align: 'center',
          show: true,
          sortable: false
        }
      ],
      search: '',
      teacherId: '',
      isLoading: false,
      createState: false
    }
  },

  created() {
    this.refresh()
  },
  computed: {
    ...mapGetters('teacher', ['teachers', 'teacher']),
    ...mapState('app', ['department']),
    ...mapState('auth', ['profile', 'role']),
    visibleHeaders() {
      return this.headers.filter(i => i.show)
    },
    teacherToDisplay() {
      const { month } = this.filters
      if (!month) {
        return this.teachers
      }
      const o = this.teachers.filter(i => {
        if (!i.dob) {
          return
        }
        const actualMonth = moment(i.dob).get('month') + 1
        return actualMonth === month
      })
      return o
    },
    titleBtn() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          return 'Thêm'
        default:
          return 'Thêm giáo viên'
      }
    }
  },
  methods: {
    ...mapActions('teacher', ['fetchTeachers', 'setTeachers']),
    getGenderLabel,
    formatDob(i) {
      if (!i) {
        return ''
      }
      return moment(i).format(`D/M/YYYY`)
    },

    refresh() {
      this.isLoading = true

      const query = {
        status: 'active',
        department: this.department.id,
        ...this.filters
      }
      delete query.month

      if (!query.status) {
        delete query.status
      }

      this.fetchTeachers(query).then(() => {
        this.isLoading = false
      })
    },
    onFilterChanged(query) {
      this.filters = query
      this.refresh()
    },
    getColor(status) {
      if (status === 'active') return 'green--text'
      if (status === 'blocked') return 'red--text'
      else return 'gray--text'
    },
    onToggleHeader(key, value) {
      this.headers = this.headers.map(i => {
        if (i.value === key) {
          return { ...i, show: value }
        }
        return i
      })
    }
  },
  filters: {
    getStatus(status) {
      if (status === 'blocked') return 'Không dạy'
      if (status === 'active') return 'Đang dạy'
      return status
    },
    getMajors(majors) {
      if (majors && majors.length > 0) {
        return majors.map(c => c.title).join(' ,')
      } else return ''
    }
  }
}
</script>
